<crm-newsletter-template-form
  *ngIf="(loading$ | async) === false"
  [data]="template"
  [canDelete]="(form$ | async)?.isEdit"
  [isModal]="true"
  [companies]="companies"
  [emails]="emails"
  [arraySms]="arraySms"
  [userGroups]="userGroups"
  [externalUsers]="externalUsers"
  [recipientUsers]="recipientUsers"
  [directions]="directions"
  (save)="saveNewsletterTemplate($event)"
  (delete)="deleteNewsletterTemplate()"></crm-newsletter-template-form>

<crm-spinner *ngIf="loading$ | async"></crm-spinner>
